import z from 'zod'
import { ERROR_DEFAULT } from 'features/common/core/errors'
import api from 'features/common/transport'

const sendCodeResponseSchema = z.object({
    stars_average: z.number()
})

const getStars = async (orgId: number) => {
    const res = await api.get(`organization/stars/${orgId}`)

    const parseRes = sendCodeResponseSchema.safeParse(await res.json())
    if (parseRes.success) {
        return parseRes.data.stars_average
    }

    throw new Error(ERROR_DEFAULT)
}
export default getStars
